import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { ButtonComponent, IconLegacyComponent } from '@ftr/foundation'
import { LaunchDarklyModule } from '@ftr/ui-feature-flags'
import { SingleSignOnComponent } from './single-sign-on.component'

@NgModule({
  imports: [ButtonComponent, CommonModule, IconLegacyComponent, LaunchDarklyModule, RouterModule],
  declarations: [SingleSignOnComponent],
  exports: [SingleSignOnComponent],
})
export class SingleSignOnModule {}
